import { useParams, useNavigate } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import "../css/Gallery.css"

export default function GalleryHeader({ title }) {
    const { year } = useParams();
    const navigate = useNavigate();

    return (
        <div className="header-bar">
            <button className="go-back-button" onClick={() => navigate(`/#year-${year}`)}><HomeIcon /></button>
            <h2 style={{ margin: 0 }}>{title}</h2>
        </div>
    );
}
